import React from 'react';
import { Register } from '../factory';
import Search from '../../common/search';
import { querySchoolList, queryCollegeList, queryMajorList } from '../../../api/dict';

const keyList = ['school', 'college', 'major'];
const defaultValue = {
    school: null,
    college: null,
    major: null,
};
@Register({ name: 'dy-school' })
class DySchool extends React.Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            schoolVisit: false,
            collegeVisit: false,
            majorVisit: false,

            schoolList: [],
            collegeList: [],
            majorList: [],

            ...defaultValue,
        };
    }

    componentWillMount() {
        this.setValue(this.props.defaultAnswer)
    }

    handleCloseSearch = (key: string) => {
        // console.log(key)
        // const { value } = this.props;
        // let newValue = value ? value : defaultValue;
        // this.setState({
        //     ...newValue
        // }, () => {
        // this.props.onChange(value ? value : null);
        this.handleToggleSearch(key, false);
        // })
    };
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps.defaultAnswer) !== JSON.stringify(this.props.defaultAnswer)) {
            this.setValue(nextProps.defaultAnswer)
        }
    }
    setValue = (val) => {
        if(!!val && typeof val === "object") {
            this.setState(val)
        }
    }

    handleToggleSearch = (key: string, b: boolean) => {
        const { school, college, major } = this.state;
        let keyStr: string = key;
        if (b) {
            if ((key === 'major' || key === 'college') && !school) {
                keyStr = 'school';
            } else if (key === 'major' && !college) {
                keyStr = 'college';
            }

            if (keyStr == 'college') {
                this.getCollegeList();
            }
            if (keyStr == 'major') {
                this.getMajorList();
            }
        }

        this.setState({
            [`${keyStr}Visit`]: b,
        });
    };

    handleSearchChange = (key, val) => {
        this.setState(
            {
                [key]: val,
                [`${key}Visit`]: false,
                ...(key == 'school'
                    ? {
                          college: null,
                          major: null,
                      }
                    : key == 'college' && {
                          major: null,
                      }),
            },
            () => {
                const { name } = this.props;
                // 选中参数与那么对应情况下，执行保存
                const { school, college, major } = this.state;
                if (
                    (name === '学校' && school) ||
                    (name === '学院' && school && college) ||
                    (name === '专业' && school && college && major)
                ) {
                    this.props.onChange &&
                        this.props.onChange({
                            school,
                            college,
                            major,
                        });
                } else {
                    this.props.onChange && this.props.onChange(null);
                    this.handleToggleSearch(keyList[keyList.indexOf(key) + 1], true);
                }
            }
        );
    };

    getSchoolList = async (val = '') => {
        if (!val) {
            return;
        }
        this.setState({
            loading: true,
        });

        let res = await querySchoolList({
            fuzzy: true,
            name: val,
        });
        this.setState({
            loading: false,
            schoolList: !res.status ? res.result : [],
        });
    };
    getCollegeList = async (val = '') => {
        this.setState({
            loading: true,
        });

        let res = await queryCollegeList({
            fuzzy: true,
            schoolGuId: this.state.school.guid,
            name: val,
        });
        this.setState({
            loading: false,
            collegeList: !res.status ? res.result : [],
        });
    };
    getMajorList = async (val = '') => {
        this.setState({
            loading: true,
        });

        let res = await queryMajorList({
            fuzzy: true,
            collegeId: this.state.college.id,
            schoolGuId: this.state.school.guid,
            name: val,
        });
        this.setState({
            loading: false,
            majorList: !res.status ? res.result : [],
        });
    };

    render() {
        const { schoolVisit, collegeVisit, majorVisit, schoolList, collegeList, majorList, school, college, major, loading } = this.state;
        let { className, name, value, defaultAnswer } = this.props;
        return (
            <div className={`dy-fm-item ${className ? className : ''}`}>
                <div className={`dy-fm-item-pick-view ${school ? 'edited' : ''}`} onClick={() => this.handleToggleSearch('school', true)}>
                    {school ? school.name : '请选择学校'}
                </div>

                {name !== '学校' && (
                    <div
                        className={`dy-fm-item-pick-view ${college ? 'edited' : ''}`}
                        onClick={() => this.handleToggleSearch('college', true)}
                    >
                        {college ? college.name : '请选择院校'}
                    </div>
                )}

                {name === '专业' && (
                    <div className={`dy-fm-item-pick-view ${major ? 'edited' : ''}`} onClick={() => this.handleToggleSearch('major', true)}>
                        {major ? major.name : '请选择专业'}
                    </div>
                )}

                <Search
                    title="请选择学校"
                    visible={schoolVisit}
                    data={schoolList}
                    loading={loading}
                    onClose={() => this.handleCloseSearch('school')}
                    onSearch={this.getSchoolList}
                    onSelect={val => this.handleSearchChange('school', val)}
                />
                <Search
                    title="请选择学院"
                    visible={collegeVisit}
                    data={collegeList}
                    loading={loading}
                    onClose={() => this.handleCloseSearch('college')}
                    onSearch={this.getCollegeList}
                    onSelect={val => this.handleSearchChange('college', val)}
                />
                <Search
                    title="请选择专业"
                    visible={majorVisit}
                    data={majorList}
                    loading={loading}
                    onClose={() => this.handleCloseSearch('major')}
                    onSearch={this.getMajorList}
                    onSelect={val => this.handleSearchChange('major', val)}
                />
            </div>
        );
    }
}

export default DySchool;
